import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CountUp from "react-countup";

const TeacherDashboard = () => {
  const routes = all_routes;
  const [showFABModal, setShowFABModal] = useState(false);

  const currentTime = new Date().toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
  });

  // Mock data for current class
  const currentClass = {
    subject: "Physics",
    grade: "Grade 11B",
    room: "Lab 1",
    time: "10:00 AM - 10:45 AM",
    studentsCount: 28,
    status: "next", // next, ongoing, completed
  };

  // Mock data for attendance progress
  const attendanceProgress = {
    completed: 3,
    total: 7,
    percentage: Math.round((3 / 7) * 100),
  };

  // Mock data for my classes
  const myClasses = [
    { code: "10A", subject: "Mathematics", students: 32, color: "primary" },
    { code: "11B", subject: "Physics", students: 28, color: "success" },
    { code: "9C", subject: "Mathematics", students: 30, color: "warning" },
    { code: "12A", subject: "Advanced Math", students: 25, color: "info" },
  ];

  // Mock data for important notifications
  const importantNotifications = [
    {
      id: 1,
      type: "meeting",
      title: "Parent Meeting Scheduled",
      message: "Meeting with Sarah Johnson's parents at 3 PM",
      time: "2 hours ago",
      urgent: true,
    },
    {
      id: 2,
      type: "deadline",
      title: "Exam Papers Due",
      message: "Submit Grade 10 math exam papers by Friday",
      time: "1 day ago",
      urgent: false,
    },
  ];

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Header */}
          <div className="row mb-4">
            <div className="col">
              <h3 className="page-title mb-2">Good Morning, Teacher! 👋</h3>
              <p className="text-muted mb-0">
                Ready to inspire minds today? Current time: {currentTime}
              </p>
            </div>
          </div>

          {/* Smart Attendance Widget - Equivalent to Smart Alerts */}
          <div className="col-12 mb-4">
            <div className="card border-start border-warning border-4">
              <div className="card-header d-flex align-items-center justify-content-between">
                <h5 className="card-title mb-0">
                  <i className="ti ti-clock me-2 text-warning"></i>Smart
                  Attendance Widget
                </h5>
                <span className="badge bg-warning">Next Class</span>
              </div>
              <div className="card-body">
                <div className="d-flex align-items-center">
                  <div className="avatar avatar-lg bg-warning-transparent me-3">
                    <i className="ti ti-user-check fs-3 text-warning"></i>
                  </div>
                  <div className="flex-fill">
                    <h6 className="mb-1">
                      {currentClass.subject} - {currentClass.grade}
                    </h6>
                    <p className="text-muted mb-2">
                      {currentClass.room} • {currentClass.time}
                    </p>
                    <div className="d-flex align-items-center gap-3">
                      <span className="badge bg-info">
                        {currentClass.studentsCount} Students
                      </span>
                      <Link
                        to={routes.attendanceTracker}
                        className="btn btn-warning btn-sm"
                      >
                        <i className="ti ti-user-check me-1"></i>
                        Take Attendance
                      </Link>
                    </div>
                  </div>
                  {/* Attendance Progress Circle */}
                  <div className="text-center">
                    <div className="avatar avatar-xl bg-success-transparent">
                      <span className="text-success fw-bold">
                        {attendanceProgress.completed}/
                        {attendanceProgress.total}
                      </span>
                    </div>
                    <p className="mb-0 small text-muted mt-1">
                      Classes Done Today
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Dashboard Widgets Row */}
          <div className="row">
            {/* Today's Classes Widget */}
            <div className="col-xxl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-xl bg-primary-transparent me-2">
                      <i className="ti ti-calendar-time fs-2"></i>
                    </div>
                    <div className="overflow-hidden flex-fill">
                      <div className="d-flex align-items-center justify-content-between">
                        <h2 className="counter">
                          <CountUp end={7} />
                        </h2>
                        <span className="badge bg-primary">Today</span>
                      </div>
                      <p>Classes Today</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between border-top mt-3 pt-3">
                    <p className="mb-0">
                      Completed:{" "}
                      <span className="text-success fw-semibold">
                        {attendanceProgress.completed}
                      </span>
                    </p>
                    <span className="text-light">|</span>
                    <p className="mb-0">
                      Remaining:{" "}
                      <span className="text-info fw-semibold">
                        {attendanceProgress.total -
                          attendanceProgress.completed}
                      </span>
                    </p>
                  </div>
                  <Link
                    to={routes.teachersRoutine}
                    className="btn btn-primary btn-sm mt-2 w-100"
                  >
                    View Schedule
                  </Link>
                </div>
              </div>
            </div>

            {/* Attendance Rate Widget */}
            <div className="col-xxl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-xl bg-success-transparent me-2">
                      <i className="ti ti-user-check fs-2"></i>
                    </div>
                    <div className="overflow-hidden flex-fill">
                      <div className="d-flex align-items-center justify-content-between">
                        <h2 className="counter text-success">
                          <CountUp end={89} />%
                        </h2>
                        <span className="badge bg-success">Excellent</span>
                      </div>
                      <p>Attendance Rate</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between border-top mt-3 pt-3">
                    <p className="mb-0">
                      Present:{" "}
                      <span className="text-success fw-semibold">156</span>
                    </p>
                    <span className="text-light">|</span>
                    <p className="mb-0">
                      Absent:{" "}
                      <span className="text-danger fw-semibold">19</span>
                    </p>
                  </div>
                  <Link
                    to={routes.attendanceTracker}
                    className="btn btn-success btn-sm mt-2 w-100"
                  >
                    Track Attendance
                  </Link>
                </div>
              </div>
            </div>

            {/* Homework Due Widget */}
            <div className="col-xxl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-xl bg-warning-transparent me-2">
                      <i className="ti ti-book fs-2"></i>
                    </div>
                    <div className="overflow-hidden flex-fill">
                      <div className="d-flex align-items-center justify-content-between">
                        <h2 className="counter text-warning">
                          <CountUp end={12} />
                        </h2>
                        <span className="badge bg-warning">Pending</span>
                      </div>
                      <p>Homework Due</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between border-top mt-3 pt-3">
                    <p className="mb-0">
                      Submitted:{" "}
                      <span className="text-success fw-semibold">143</span>
                    </p>
                    <span className="text-light">|</span>
                    <p className="mb-0">
                      Pending:{" "}
                      <span className="text-warning fw-semibold">12</span>
                    </p>
                  </div>
                  <Link
                    to={routes.manageHomework}
                    className="btn btn-warning btn-sm mt-2 w-100"
                  >
                    Manage Homework
                  </Link>
                </div>
              </div>
            </div>

            {/* Upcoming Exams Widget */}
            <div className="col-xxl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-xl bg-info-transparent me-2">
                      <i className="ti ti-clipboard-list fs-2"></i>
                    </div>
                    <div className="overflow-hidden flex-fill">
                      <div className="d-flex align-items-center justify-content-between">
                        <h2 className="counter text-info">
                          <CountUp end={3} />
                        </h2>
                        <span className="badge bg-info">This Week</span>
                      </div>
                      <p>Upcoming Exams</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between border-top mt-3 pt-3">
                    <p className="mb-0">
                      Scheduled:{" "}
                      <span className="text-info fw-semibold">3</span>
                    </p>
                    <span className="text-light">|</span>
                    <p className="mb-0">
                      Graded:{" "}
                      <span className="text-success fw-semibold">8</span>
                    </p>
                  </div>
                  <Link
                    to={routes.gradeEntry}
                    className="btn btn-info btn-sm mt-2 w-100"
                  >
                    Grade Entry
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Secondary Widgets Row */}
          <div className="row">
            {/* My Classes Widget */}
            <div className="col-xxl-4 col-sm-6">
              <div className="card">
                <div className="card-header d-flex align-items-center justify-content-between">
                  <h5 className="card-title mb-0">My Classes</h5>
                  <Link
                    to={routes.teachersRoutine}
                    className="btn btn-outline-primary btn-sm"
                  >
                    View All
                  </Link>
                </div>
                <div className="card-body">
                  <div className="row g-2">
                    {myClasses.map((classItem, index) => (
                      <div key={index} className="col-6">
                        <Link
                          to={routes.attendanceTracker}
                          className="card bg-light-subtle text-decoration-none h-100"
                        >
                          <div className="card-body text-center p-3">
                            <div className="mb-2">
                              <span
                                className={`badge bg-${classItem.color} fs-6 px-3 py-2`}
                              >
                                {classItem.code}
                              </span>
                            </div>
                            <h6 className="mb-1">{classItem.subject}</h6>
                            <p className="text-muted mb-0 small">
                              {classItem.students} students
                            </p>
                          </div>
                        </Link>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Important Notifications Widget */}
            <div className="col-xxl-4 col-sm-6">
              <div className="card">
                <div className="card-header d-flex align-items-center justify-content-between">
                  <h5 className="card-title mb-0">Important Notifications</h5>
                  <span className="badge bg-danger">
                    {importantNotifications.filter((n) => n.urgent).length}
                  </span>
                </div>
                <div className="card-body">
                  {importantNotifications.map((notification) => (
                    <div
                      key={notification.id}
                      className={`d-flex align-items-center mb-3 p-2 rounded ${
                        notification.urgent
                          ? "bg-warning-light"
                          : "bg-info-light"
                      }`}
                    >
                      <div
                        className={`avatar avatar-sm me-3 ${
                          notification.urgent ? "bg-warning" : "bg-info"
                        }`}
                      >
                        <i
                          className={`ti ${
                            notification.type === "meeting"
                              ? "ti-calendar"
                              : "ti-clipboard-list"
                          } text-white`}
                        ></i>
                      </div>
                      <div className="flex-fill">
                        <p className="mb-1 fw-semibold">{notification.title}</p>
                        <p className="mb-1 small">{notification.message}</p>
                        <small className="text-muted">
                          {notification.time}
                        </small>
                      </div>
                      {notification.urgent && (
                        <i className="ti ti-alert-triangle text-warning"></i>
                      )}
                    </div>
                  ))}
                  <Link
                    to={routes.teacherSchedule}
                    className="btn btn-outline-primary btn-sm w-100"
                  >
                    View All Notifications
                  </Link>
                </div>
              </div>
            </div>

            {/* Quick Actions Widget */}
            <div className="col-xxl-4 col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title mb-0">Quick Actions</h5>
                </div>
                <div className="card-body">
                  <div className="d-grid gap-2">
                    <Link
                      to={routes.attendanceTracker}
                      className="btn btn-success d-flex align-items-center"
                    >
                      <i className="ti ti-user-check me-2"></i>
                      <span>Mark Attendance</span>
                      <span className="ms-auto badge bg-white text-success">
                        3 pending
                      </span>
                    </Link>
                    <Link
                      to={routes.manageHomework}
                      className="btn btn-warning d-flex align-items-center"
                    >
                      <i className="ti ti-book me-2"></i>
                      <span>Create Homework</span>
                      <span className="ms-auto badge bg-white text-warning">
                        New
                      </span>
                    </Link>
                    <Link
                      to={routes.alertParents}
                      className="btn btn-info d-flex align-items-center"
                    >
                      <i className="ti ti-bell me-2"></i>
                      <span>Send Alert</span>
                    </Link>
                    <Link
                      to={routes.gradeEntry}
                      className="btn btn-primary d-flex align-items-center"
                    >
                      <i className="ti ti-clipboard-list me-2"></i>
                      <span>Enter Grades</span>
                      <span className="ms-auto badge bg-white text-primary">
                        12 due
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* FAB Button */}
      <button
        className="btn btn-primary rounded-circle shadow-lg"
        style={{
          position: "fixed",
          bottom: "100px",
          right: "30px",
          width: "60px",
          height: "60px",
          zIndex: 1050,
        }}
        onClick={() => setShowFABModal(true)}
      >
        <i className="ti ti-plus fs-4"></i>
      </button>

      {/* FAB Modal */}
      {showFABModal && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Quick Actions</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowFABModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="d-grid gap-2">
                  <Link
                    to={routes.manageHomework}
                    className="btn btn-warning text-start"
                    onClick={() => setShowFABModal(false)}
                  >
                    <i className="ti ti-book me-3"></i>
                    Add Homework
                  </Link>
                  <Link
                    to={routes.gradeEntry}
                    className="btn btn-success text-start"
                    onClick={() => setShowFABModal(false)}
                  >
                    <i className="ti ti-clipboard-list me-3"></i>
                    Add Grades
                  </Link>
                  <Link
                    to={routes.alertParents}
                    className="btn btn-info text-start"
                    onClick={() => setShowFABModal(false)}
                  >
                    <i className="ti ti-bell me-3"></i>
                    Create Announcement
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TeacherDashboard;
